import { Injectable } from '@angular/core';
import { Settings } from '../../core/settings';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { deserialize } from 'santee-dcts';
import { SponsorStudySiteIdentity, SponsorStudySiteIdentitiesReadModel } from './sponsor-study-site-identity';
import { map } from 'rxjs/operators';
import { orderBy } from 'lodash';

@Injectable()
export class SponsorStudySiteIdentitiesStorage {
    constructor(
        private readonly settings: Settings,
        private readonly http: HttpClient
    ) {}

    public loadSponsorStudySiteIdentities(studyId: number): Observable<SponsorStudySiteIdentity[]> {
        return this.http.get(`${this.settings.apiUrl}/sponsor/study/${studyId}/site-identities`).pipe(
            map((response) => {
                const siteIdentities = deserialize(response, SponsorStudySiteIdentitiesReadModel).siteIdentities;
                return orderBy(siteIdentities, s => s.siteDisplayName);
            }),
        );
    }
}